import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Footerimage from '../../assets/images/black_appstore.webp';
import Footerimage01 from '../../assets/images/black_google_play.webp';
import PlayStoreLink from './PlayStoreLink';
import AppStoreLink from './AppStoreLink';
import { supabase } from '../../lib/supabase';
import { siteCopy } from '../../content/siteCopy';
import { BRAND, brandUrl, publicAsset } from '../../constants/brand';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [honeypot, setHoneypot] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const { footer } = siteCopy;

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (honeypot) return;
    const value = (email || '').trim().toLowerCase();
    if (!value) return;
    if (!supabase) {
      setStatus('error');
      return;
    }
    setLoading(true);
    setStatus(null);
    const { error } = await supabase.from('newsletter_signups').insert({ email: value, website: '' });
    setLoading(false);
    if (error) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setEmail('');
  };

  return (
    <footer>
      <div className="top_footer" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-12">
              <div className="abt_side">
                <div className="logo">
                  <img src={publicAsset(BRAND.logos.white)} alt={`${siteCopy.brand} logo`} />
                </div>
                <p className="footer_tagline footer_tagline--full">{footer.tagline}</p>
                {footer.shortTagline ? (
                  <p className="footer_tagline footer_tagline--short">{footer.shortTagline}</p>
                ) : null}
                <ul className="app_btn">
                  <li>
                    <AppStoreLink>
                      <img src={Footerimage} alt="Download on the App Store" />
                    </AppStoreLink>
                  </li>
                  <li>
                    <PlayStoreLink>
                      <img src={Footerimage01} alt="Get it on Google Play" />
                    </PlayStoreLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-12">
              <div className="links">
                <h5>Quick Links</h5>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/features">Features</Link></li>
                  <li><Link to="/changelog">Changelog</Link></li>
                  <li>
                    <a href={brandUrl('roadmap')} target="_blank" rel="noopener noreferrer">
                      Roadmap
                    </a>
                  </li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-12">
              <div className="links">
                <h5>Legal</h5>
                <ul>
                  <li><Link to="/privacy-policy">Privacy</Link></li>
                  <li><Link to="/terms-of-use">Terms</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12">
              <h5>Subscribe</h5>
              <div className="news_letter">
                <p>{footer.subscribeBlurb}</p>
                <form onSubmit={handleSubscribe}>
                  <input
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
                    aria-hidden="true"
                  />
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      required
                    />
                    <button type="submit" className="btn" aria-label="subscribe" disabled={loading}>
                      <i className="icofont-paper-plane" />
                    </button>
                  </div>
                  {status === 'success' && <p className="note">Thanks! You&apos;re on the list.</p>}
                  {status === 'error' && <p className="note">Something went wrong. Please try again.</p>}
                  <p className="note">{footer.subscribeLegal}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_footer">
          <div className="container">
            <p className="note" style={{ marginBottom: '1rem', fontSize: '0.85rem' }}>
              {siteCopy.disclaimer}
            </p>
            <div className="row">
              <div className="col-md-6">
                <p>{footer.copyright}</p>
              </div>
              <div className="col-md-6 text-md-right">
                <p>
                  <Link to={`mailto:${footer.supportEmail}`}>{footer.supportEmail}</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
